import { render, staticRenderFns } from "./SlugInput.vue?vue&type=template&id=22b3566f"
import script from "./SlugInput.vue?vue&type=script&setup=true&lang=ts"
export * from "./SlugInput.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports